import React, { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import Pagination from "../Constant/Pagination";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSmallSearchInput from "../Constant/DebounceSmallSearchInput";
import { toast } from "react-toastify";
import GlobalSearchableDropdown from "../Constant/SearchableDropdown";
import { dateRangeOptions } from "../../utilities";
import { subDays, startOfMonth, endOfMonth, subMonths,format } from "date-fns";
import DatePicker from "react-datepicker";
const stockLogs = [
  {
    date: "2025-08-01",
    category: "Electronics",
    subcategory: "Mobile Phones",
    logType: "OUT",
    quantity: 10,
  },
  {
    date: "2025-08-02",
    category: "Electronics",
    subcategory: "Laptops",
    logType: "IN",
    quantity: 5,
  },
  {
    date: "2025-08-03",
    category: "Electronics",
    subcategory: "Headphones",
    logType: "OUT",
    quantity: 20,
  },
  {
    date: "2025-08-04",
    category: "Electronics",
    subcategory: "Smart Watches",
    logType: "IN",
    quantity: 15,
  },
  {
    date: "2025-08-05",
    category: "Fashion",
    subcategory: "Men's Shirts",
    logType: "OUT",
    quantity: 12,
  },
  {
    date: "2025-08-06",
    category: "Fashion",
    subcategory: "Women's Dresses",
    logType: "OUT",
    quantity: 8,
  },
  {
    date: "2025-08-07",
    category: "Fashion",
    subcategory: "Shoes",
    logType: "IN",
    quantity: 25,
  },
  {
    date: "2025-08-08",
    category: "Fashion",
    subcategory: "Bags",
    logType: "IN",
    quantity: 18,
  },
  {
    date: "2025-08-09",
    category: "Home Appliances",
    subcategory: "Refrigerators",
    logType: "OUT",
    quantity: 2,
  },
  {
    date: "2025-08-10",
    category: "Home Appliances",
    subcategory: "Washing Machines",
    logType: "OUT",
    quantity: 1,
  },
  {
    date: "2025-08-11",
    category: "Home Appliances",
    subcategory: "Microwaves",
    logType: "IN",
    quantity: 10,
  },
  {
    date: "2025-08-12",
    category: "Home Appliances",
    subcategory: "Air Conditioners",
    logType: "IN",
    quantity: 6,
  },
  {
    date: "2025-08-13",
    category: "Groceries",
    subcategory: "Rice",
    logType: "OUT",
    quantity: 50,
  },
  {
    date: "2025-08-14",
    category: "Groceries",
    subcategory: "Wheat Flour",
    logType: "OUT",
    quantity: 30,
  },
  {
    date: "2025-08-15",
    category: "Groceries",
    subcategory: "Cooking Oil",
    logType: "IN",
    quantity: 20,
  },
  {
    date: "2025-08-16",
    category: "Groceries",
    subcategory: "Snacks",
    logType: "IN",
    quantity: 40,
  },
  {
    date: "2025-08-17",
    category: "Sports",
    subcategory: "Cricket Bats",
    logType: "OUT",
    quantity: 7,
  },
  {
    date: "2025-08-18",
    category: "Sports",
    subcategory: "Footballs",
    logType: "IN",
    quantity: 12,
  },
  {
    date: "2025-08-19",
    category: "Sports",
    subcategory: "Badminton Rackets",
    logType: "IN",
    quantity: 15,
  },
  {
    date: "2025-08-20",
    category: "Sports",
    subcategory: "Gym Equipment",
    logType: "OUT",
    quantity: 5,
  },
];


const InventoryLog = ({param,setParam}) => {
  const [data, setData] = useState([...stockLogs]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(dateRangeOptions[0]);
    const [showDatePicker, setShowDatePicker] = useState(false);
  const [total, setTotal] = useState(0);
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
      page: 1,
    }));
  };
const handleDateRangeChange = (option) => {
    setSelectedDate(option);
    if (!option) {
      setParam({
        ...param,
        start_date: "",
        end_date: "",
        page: "1",
      });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "today":
        startDate = new Date();
        endDate = new Date();
        break;
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };
  return (
    <div>
      <div className="card">
        <div className="p-4 d-flex justify-content-between flex-wrap gap-2">
          <div className="flex-fill flex-md-grow-0">
            <DebounceSmallSearchInput handleSearchChange={handleSearchChange} />
          </div>
          <div className="d-flex gap-2 flex-wrap">
            <div>
              <GlobalSearchableDropdown
                options={[]}
                selected={null}
                onSelect={(item) => undefined}
                placeholder="Category"
              />
            </div>
            <div>
              <GlobalSearchableDropdown
                options={[]}
                selected={null}
                onSelect={(item) => undefined}
                placeholder="SubCategory"
              />
            </div>
            <div>
              <GlobalSearchableDropdown
                options={[]}
                selected={null}
                onSelect={(item) => undefined}
                placeholder="Status"
              />
            </div>
            {showDatePicker && (
                          <div className="">
                            <DatePicker
                              selectsRange
                              startDate={
                                param?.start_date ? new Date(param.start_date) : null
                              }
                              endDate={param?.end_date ? new Date(param.end_date) : null}
                              onChange={(update) => {
                                const [start, end] = update;
                                setParam((prev) => ({
                                  ...prev,
                                  start_date: start ? format(start, "yyyy-MM-dd") : "",
                                  end_date: end ? format(end, "yyyy-MM-dd") : "",
                                  page: 1,
                                }));
                              }}
                              isClearable
                              placeholderText="Select date range"
                              className="form-control"
                              style={{
                                fontSize: "0.5rem",
                              }}
                            />
                          </div>
                        )}
                        <div className="">
                          <GlobalSearchableDropdown
                            options={dateRangeOptions}
                            selected={selectedDate}
                            onSelect={(item) => handleDateRangeChange(item)}
                            placeholder="Period"
                          />
                        </div>
          </div>
        </div>
        {loading ? (
          <div className="text-center my-4">
            <Spinner animation="border" />
          </div>
        ) : error ? (
          <div className="text-center my-4 text-danger">{error}</div>
        ) : data && data?.length > 0 ? (
          <div className="table-responsive">
            <table className="table fs-6 mb-0 align-middle">
              <thead className="table-light custom-thead">
                <tr>
                    <th>SDate</th>
                  <th>Category</th>
                  <th>Sub category</th>
                  <th>Quantity</th>
                  <th>Log Type</th>
                </tr>
              </thead>
              <tbody>
                {data?.map((item, index) => (
                  <tr key={item.id}>
                    <td>{item?.date || "-"}</td>
                    <td>{item?.category || "-"}</td>
                    <td>{item?.subcategory || "-"}</td>
                    <td>{item?.quantity || "-"}</td>
                    <td>{item?.logType || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="text-center my-4">No data found</div>
        )}
        {!loading && data?.length > 0 && (
          <div className="p-4">
            <Pagination
              currentPage={param.page}
              recordsPage={param.page_size}
              dataLength={total}
              handlePagination={handlePageChange}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default InventoryLog;
